import styles from './CheckBox.module.css';
import PropTypes from 'prop-types';

const CheckBox = ({ isChecked, handleCheckboxChange, title, description }) => {
  return (
    <div className={styles.checkBoxWrapper}>
      <input
        type="checkbox"
        checked={isChecked}
        className={styles.checkBox}
        onChange={handleCheckboxChange}
      />
      <div className={styles.checkBoxLabelWrapper}>
        <label className={styles.checkBoxLabelTitle}>{title}</label>
        <label className={styles.checkBoxLabelDescription}>{description}</label>
      </div>
    </div>
  );
};

CheckBox.displayName = 'CheckBox';

CheckBox.defaultProps = {
  title: '',
  description: '',
  isChecked: false,
  handleCheckboxChange: () => {},
};

CheckBox.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  isChecked: PropTypes.bool,
  handleCheckboxChange: PropTypes.func,
};

export default CheckBox;
